import React, { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { api, setToken } from '../api';
import { useAuth } from '../auth';
import { useToast } from '../components/ui';

export default function Profile() {
  const { user } = useAuth();
  const toast = useToast();
  const [cur, setCur] = useState('');
  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');
  const [saving, setSaving] = useState(false);

  const changePw = async (e) => {
    e.preventDefault();
    if (pw1 !== pw2) return toast('Passwörter stimmen nicht überein', 'err');
    setSaving(true);
    try {
      const res = await api.put('/users/me/password', { currentPassword: cur, newPassword: pw1 });
      if (res && res.token) setToken(res.token); // Sitzung mit neuem Token fortführen
      toast('Passwort geändert');
      setCur(''); setPw1(''); setPw2('');
    } catch (err) { toast(err.message, 'err'); }
    finally { setSaving(false); }
  };

  return (
    <>
      <div className="page-head"><div><h1>Mein Profil</h1><div className="sub">Angemeldet als <strong>{user.username}</strong>{user.isAdmin ? ' · Administrator' : ''}</div></div></div>
      <div className="card card-pad" style={{ maxWidth: 480 }}>
        <div className="card-title"><KeyRound size={18} /> Passwort ändern</div>
        <form onSubmit={changePw} style={{ display: 'flex', flexDirection: 'column', gap: 14, marginTop: 12 }}>
          <div className="form-group"><label>Aktuelles Passwort</label><input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required /></div>
          <div className="form-group"><label>Neues Passwort</label><input type="password" value={pw1} onChange={(e) => setPw1(e.target.value)} required minLength={8} placeholder="mind. 8 Zeichen" /></div>
          <div className="form-group"><label>Neues Passwort wiederholen</label><input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required minLength={8} /></div>
          <button className="btn btn-primary" disabled={saving}>{saving ? 'Speichern…' : 'Passwort ändern'}</button>
        </form>
      </div>
    </>
  );
}
